import { canv } from "@/canv/global";
import { getNewStartY } from "@/shapeStorage/utils";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeMerge extends Shape {
    width = 200;
    height = 174;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
    ) {
        const k = (height * width) / (height + width);
        const allowedWidth = k;
        const allowedHeight = k - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();
        this.updateTextDims(textPart);

        textPart.startX = x + width / 2 - textPart.width / 2;

        textPart.startY = getNewStartY(textPart, y, allowedHeight, 0, 0);

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number) {
        let r = height / 30;

        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x + 2 * r, y); // 2*r потому что с просто r немного не правильно отображается угол
        canv.ctx.arcTo(x + width, y, x + (width * 1) / 2, y + height, r);
        canv.ctx.arcTo(x + (width * 1) / 2, y + height, x, y, r);
        canv.ctx.arcTo(x, y, x + width, y, r);
        canv.ctx.closePath();
    }

    clipAriaCoordinateY(y: number, _h: number, allowedHeight: number) {
        return y + allowedHeight / 2;
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" d="M2.84 2.75h18.32a1.56 1.56 0 0 1 1.37 2.35l-9.16 15.38a1.6 1.6 0 0 1-2.74 0L1.47 5.1a1.56 1.56 0 0 1 1.37-2.35Z"/>
            </svg>
        `;
    }
}
